import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getFrasesByPlantelThunk,
  getTalentsByPlantelThunk,
} from "../../store/reducers/plantels/plantels.thunks";
import TalentsByPlantelTable from "./TalentsByPlantelTable";
import {
  openTalentForm,
  setTalentsPage,
} from "../../store/reducers/plantels/talentsByPlantels.reducer";
import Pagination from "../UI/Pagination";
import { Icon } from "@iconify/react/dist/iconify.js";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import TalentByPlantelFormModal from "./TalentByPlantelFormModal";
import TalentByPlantelViewModal from "./TalentByPlantelViewModal";
import TalentByPlantelConfirmModal from "./TalentByPlantelConfirmModal";
import FrasesTab from "./FrasesTab";
import ResponsePhrasesTab from "./ResponsePhrasesTab";
import ResponsePhraseViewModal from "./ResponsePhraseViewModal";
import ResponsePhraseEditModal from "./ResponsePhraseEditModal";
import PhraseBuilderLayoutPlantel from "../plantelAlgorithm/PhraseBuilderLayoutPlantel";
import ConfiguracionesAdicionalesTab from "../configuracionTalentos/ConfiguracionesAdicionalesTab";

const tabs = [
  { key: "talentos", label: "Talentos" },
  { key: "frases", label: "Frases" },
  { key: "respuestas", label: "Frases de respuesta" },
  { key: "algoritmo", label: "Configuración de algoritmo" },
  { key: "configuraciones-adicionales", label: "Configuraciones adicionales" },
];

const PlantelTabs = ({ plantelId }) => {
  const dispatch = useDispatch();
  const { list, loading, error, page, pageSize, count } = useSelector(
    (state) => state.talentosByPlantels,
  );

  const frasesState = useSelector((state) => state.frasesByPlantel);

  // console.log(list);
  const [activeTab, setActiveTab] = useState("talentos");

  useEffect(() => {
    if (plantelId) {
      dispatch(getTalentsByPlantelThunk({ plantelId, page }));
    }
  }, [plantelId, page, dispatch]);

  useEffect(() => {
    if (activeTab === "frases" && plantelId) {
      dispatch(
        getFrasesByPlantelThunk({
          plantelId,
          page: frasesState.page,
        }),
      );
    }
  }, [activeTab, plantelId, frasesState.page, dispatch]);

  if (loading) return <Loader center text="Cargando talentos..." delay={200} />;
  if (error) return <Alert />;

  const handlePageChange = (newPage) => {
    dispatch(setTalentsPage(newPage));
  };
  return (
    <div className="card radius-8">
      {/* HEADER — solo navegación */}
      <div className="card-header border-bottom bg-base ps-0 py-0">
        <ul className="nav bordered-tab nav-pills mb-0 flex-wrap">
          {tabs.map((tab) => (
            <li className="nav-item" key={tab.key}>
              <button
                className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* BODY — contenido */}
      <div className="card-body">
        {activeTab === "talentos" && (
          <>
            <div className="d-flex justify-content-end mb-3">
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2 radius-8"
                style={{ height: "44px", minWidth: "140px" }}
                onClick={() => dispatch(openTalentForm())}
              >
                <Icon icon="mdi:plus" width="20" />
                <span className="d-none d-sm-inline fw-medium">
                  Nuevo talento
                </span>
                <span className="d-inline d-sm-none fw-medium">Nuevo</span>
              </button>
            </div>
            <TalentsByPlantelTable talents={list} />

            <Pagination
              page={page}
              count={count}
              pageSize={pageSize}
              onPageChange={handlePageChange}
            />
            <TalentByPlantelFormModal plantelId={plantelId} />
            <TalentByPlantelViewModal />
            <TalentByPlantelConfirmModal />
          </>
        )}
        {activeTab === "frases" && (
          <>
            <FrasesTab plantelId={plantelId} />
          </>
        )}
        {activeTab === "respuestas" && (
          <>
            <ResponsePhrasesTab plantelId={plantelId} />
            <ResponsePhraseViewModal />
            <ResponsePhraseEditModal plantelId={plantelId} />
          </>
        )}
        {activeTab === "algoritmo" && (
          <PhraseBuilderLayoutPlantel plantelId={plantelId} />
        )}
        {activeTab === "configuraciones-adicionales" && (
          <ConfiguracionesAdicionalesTab plantelId={plantelId} />
        )}
      </div>
    </div>
  );
};

export default PlantelTabs;
